import {
  generateMockMatterSettlementDemandPayload,
  generateMockMatterSettlementOfferPayload,
} from "@/lib/data/factories/matter-subitem-payload-factory";
import { useCreateMatterSettlementDemand } from "@/lib/data/react-query/matters/matter-settlement-demand";
import { useCreateMatterSettlementOffer } from "@/lib/data/react-query/matters/matter-settlement-offer";
import { useCallback } from "react";
import { createMultiple } from "./mock-api-utils";

export const useCreateMockMatterSettlementItems = () => {
  const createSettlementDemand = useCreateMatterSettlementDemand();
  const createSettlementOffer = useCreateMatterSettlementOffer();

  const createMockMatterSettlementDemand = useCallback(
    async (
      matterId: string,
      matterInsuranceId: string,
      count = 1,
      overrides: Record<string, unknown> = {},
    ) =>
      createMultiple(count, () =>
        createSettlementDemand.mutateAsync(
          generateMockMatterSettlementDemandPayload(
            matterId,
            matterInsuranceId,
            overrides,
          ),
        ),
      ),
    [createSettlementDemand],
  );

  const createMockMatterSettlementOffer = useCallback(
    async (
      matterId: string,
      matterInsuranceId: string,
      count = 1,
      overrides: Record<string, unknown> = {},
    ) =>
      createMultiple(count, () =>
        createSettlementOffer.mutateAsync(
          generateMockMatterSettlementOfferPayload(
            matterId,
            matterInsuranceId,
            overrides,
          ),
        ),
      ),
    [createSettlementOffer],
  );

  return {
    createMockMatterSettlementDemand,
    createMockMatterSettlementOffer,
    mutations: {
      demand: createSettlementDemand,
      offer: createSettlementOffer,
    },
  };
};
